export const listReviews = /* GraphQL */ `
  query ListReviews(
    $id: ID
    $sk: ModelStringKeyConditionInput
    $filter: ModelResourceFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listResources(
      id: $id
      sk: $sk
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        sk
        name
        maturity
        createdAt
        updatedAt
        creatorId
        workspaceId
        creator {
          id
          sk
          firstName
          lastName
          avatarHash
        }
      }
      nextToken
    }
  }
`;

export const getReview = /* GraphQL */ `
  query GetReview($id: ID!, $sk: String!) {
    getResource(id: $id, sk: $sk) {
      id
      sk
      maturity
    }
  }
`;

export const listUserReviewRequests = /* GraphQL */ `
  query ListUserReviewRequests($input: ListResourcesByWorkspaceIdThenSkInput) {
    listUserReviewRequests(input: $input) {
      items {
        id
        sk
        name
        maturity
        createdAt
        updatedAt
        creatorId
        workspaceId
        resource {
          id
          sk
          name
          idInc
          isUserFavorite
          createdAt
          updatedAt
        }
        creator {
          id
          sk
          firstName
          lastName
          avatarHash
        }
      }
      nextToken
    }
  }
`;

export const createReview = /* GraphQL */ `
  mutation CreateReview($input: CreateReviewInput!) {
    createReview(input: $input) {
      id
      sk
    }
  }
`;

export const updateReview = /* GraphQL */ `
  mutation UpdateReview($input: UpdateReviewInput!) {
    updateReview(input: $input) {
      id
      sk
      name
      maturity
      creator {
        firstName
        lastName
        email
        avatarHash
        acl
        createdAt
        updatedAt
        notification {
          type
          payload
        }
      }
    }
  }
`;

export const deleteReview = /* GraphQL */ `
  mutation DeleteReview($input: DeleteReviewInput!) {
    deleteReview(input: $input) {
      id
      sk
      name
    }
  }
`;
